import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Container, 
  CssBaseline, 
  ThemeProvider, 
  createTheme,
  IconButton,
  Tooltip
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import CameraCapture from './components/CameraCapture';
import ImageList from './components/ImageList';
import Settings from './components/Settings';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const [settingsOpen, setSettingsOpen] = useState(false);

  const handleOpenSettings = () => {
    setSettingsOpen(true);
  };

  const handleCloseSettings = () => {
    setSettingsOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Truck Image Trainer
            </Typography>
            <Button color="inherit" component={Link} to="/">
              Capture and Annotate
            </Button>
            <Button color="inherit" component={Link} to="/list">
              List Training Data
            </Button>
            <Tooltip title="Settings">
              <IconButton 
                color="inherit" 
                onClick={handleOpenSettings} 
                edge="end"
              >
                <SettingsIcon />
              </IconButton>
            </Tooltip>
          </Toolbar>
        </AppBar>
        <Container>
          <Routes>
            <Route path="/" element={<CameraCapture />} />
            <Route path="/list" element={<ImageList />} />
          </Routes>
        </Container>
        
        {/* Settings Dialog */}
        <Settings open={settingsOpen} onClose={handleCloseSettings} />
      </Router>
    </ThemeProvider>
  );
}

export default App;
